
import { API_AUTH } from "./variablesAuth.tsx";
import "../App.css";
import { useEffect, useState } from "react";

export const Login = ()=>{
    const [loged, setLoged] = useState(false);
    //const [user, setUser] = useState<undefined>();

    useEffect(()=>{
        let init = {
            method: "POST",
            body: JSON.stringify({}),
            header:{
                "Content-Type":"aplication/json"
            }
        };
        fetch(API_AUTH + "/loged",init)
        .then(response=>response.json())
        .catch(err=>console.log(err))
        .then(data=>{
            console.log(data);
            if(data.status === "ok"){
                setLoged(true);
            }
            else{
                setLoged(false);
            }
        })
    },[loged])

    const submit = ()=>{
        
        let init = {
            method: "POST",
            body: JSON.stringify({
                Username:"193451171d7b0b13bcd3f18b4fbdffdc06cef145",
                Password:"193451171d7b0b13bcd3f18b4fbdffdc06cef145"
            }),
            header:{
                "Content-Type":"aplication/json",
                "Acept":"*/*"
            }
        };
        fetch(API_AUTH + "/login",init)
        .then(response=>response.json())
        .catch(err=>console.log(err))
        .then(data=>{
            console.log(data);
            if(data.status === "ok"){
                setLoged(true);
            }
            else{
                setLoged(false);
            }
        })
    }

    return(
    <>
        {
            loged?
            <div>menu</div>
            :
            <div className="d-flex justify-content-center" style={{height:"100vh",padding:"50px"}}>
                <div className="card" style={{minWidth:"300px"}}>
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h5>Inicio de Sesión</h5>
                        <div className="logo">Si.T.A.</div>
                    </div>
                    <div className="card-body">
                        <form action={API_AUTH + "/login"} method="post">
                            <div className="mb-3">
                            <label htmlFor="usuario" className="form-label">Usuario</label>
                            <input
                                type="text"
                                className="form-control"
                                name="usuario"
                                id="usuario"
                                aria-describedby="helpId"
                                placeholder=""
                            />
                            <small id="helpId" className="form-text text-muted">Nombre de Usuario</small>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="password" className="form-label">Contraseña</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    name="password"
                                    id="password"
                                    aria-describedby="helpId"
                                    placeholder=""
                                />
                                <small id="helpId" className="form-text text-muted">Clave de acceso del usuario</small>
                            </div>
                            
                        </form>
                    </div>
                    <div className="card-footer text-muted">
                        <button className="btn btn-sm btn-outline-success" onClick={submit}>LogIn</button>
                    </div>
                </div>  
            </div>
        }
    </>
    );
}